import * as React from 'react';
import { Typography } from '@mui/material';
import { selectPeriodOption } from '../../../../../../slices/orders/periodSlice';
import { AxiosResponse } from 'axios';
import fetchClient from '../../../../../../services/axios';
import LoaderThreeDots from '../../../../../../components/LoaderThreeDots';
import { SummaryProps } from './utils';
import {
  selectOrderFlowRefresh,
  setLastUpdatedChart,
  refreshOrderFlow,
} from '../../../../../../slices/utils/utilsSlice';
import { selectChannelOptions } from '../../../../../../slices/orders/channelsSlice';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import moment from 'moment';

const SummaryChart = React.lazy(() => import('./SummaryChart'));

export default function OrderSummaries() {
  const [summary, setSummary] = React.useState<SummaryProps[] | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const period = useAppSelector(selectPeriodOption);
  const channels = useAppSelector(selectChannelOptions);
  const needsRefresh = useAppSelector(selectOrderFlowRefresh);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    const controller = new AbortController();

    async function getOrdersAsync() {
      setLoading(true);
      await fetchClient
        .get('/OrderFlow/SummaryBarChart', {
          // params: { period: period.value, channels: channels?.map((x) => x.name) },
          signal: controller.signal,
          // paramsSerializer: {
          //   indexes: null, // by default: false
          // },
        })
        .then((response: AxiosResponse<SummaryProps[] | null>) => {
          setSummary(response.data);
          dispatch(refreshOrderFlow(false));
          dispatch(setLastUpdatedChart(moment()));
        })
        .catch(function (err) {
          if (err.message !== 'canceled') console.log(err);
        })
        .finally(() => setLoading(false));
    }

    if (period.error || !needsRefresh) return;
    getOrdersAsync();

    return () => controller.abort();
  }, [period, channels, needsRefresh, dispatch]);

  React.useEffect(() => {
    dispatch(refreshOrderFlow(true));
  }, [period, channels, dispatch]);

  return (
    <>
      {period.error ? (
        <Typography>Please select a period to view summaries</Typography>
      ) : loading ? (
        <LoaderThreeDots title="Loading..." />
      ) : (
        <React.Suspense fallback={<LoaderThreeDots title="Loading components ..." />}>
          <SummaryChart initialData={summary} />
        </React.Suspense>
      )}
    </>
  );
}
